export default __webpack_public_path__ + "static/anzeige-seckelmann-f7ea66035ee3526a5738445229eac907.jpg";